import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../authentication/AuthProvider';
import routes from './Routes';
import { useUserProfile } from '../../hooks/useUserProfile';

const AppRoute = () => {
    const { currentUser } = useAuth();
    const { userProfile } = useUserProfile();

    if (currentUser && !userProfile) {
        console.log('AppRoute: userProfile is not loaded yet');
        // profile is not loaded yet
        return;
    }

    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return !currentUser 
        ? <Navigate to={routes.authentication.login.build()} />
        : !userProfile?.is_onboarding_complete
            ? <Navigate to={routes.app.gettingStarted.build()} />
            : <Outlet />;
}

export default AppRoute;